export const CODE_CHANGE = 'CODE_CHANGE';

export const PARSE_ALL_SCRIPTS = 'PARSE_ALL_SCRIPTS';

export const CODE_META_DATA_RESET = 'CODE_META_DATA_RESET';

export const CODE_META_DATA_CHANGE = 'CODE_META_DATA_CHANGE';

export const CHECK_ERRORS = 'CHECK_ERRORS';

export const ERRORS_CHANGE = 'ERRORS_CHANGE';

export const SCRIPR_PARSED_OK = 'SCRIPR_PARSED_OK';

export const CODE_PARSING_REQ = 'CODE_PARSING_REQ';
export const CODE_PARSING_OK = 'CODE_PARSING_OK';

